module.exports = __webpack_public_path__ + "static/img/solutionDetailPic18.6e782ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic18.jpg
// module id = t2Nv
// module chunks = 1